import { useState, useRef } from "react";
import { Menu, MenuItem } from "@livingdesign/react";
import { More } from "@livingdesign/icons";
import QA from "../../../../consts/QA";
import SavedRecipientsDeleteModal from "../../Campaign/CampaignEdit/EditLayout/RecipientSelection/SavedRecipients/SavedRecipientsDeleteModal";
import SavedRecipientsCreateModal from "../../Campaign/CampaignEdit/EditLayout/RecipientSelection/SavedRecipients/SavedRecipientsCreateModal";
import { useRecipientFilter } from "../../../../contexts/RecipientFilter";
import { useSavedFiltersManagement } from "../../../../contexts/SavedFiltersManagement";
import SavedRecipientsShareModal from "../../Campaign/CampaignEdit/EditLayout/RecipientSelection/SavedRecipients/SavedRecipientsShareModal";
import { useAppContext } from "../../../../contexts/Core";
import { JWT } from "../../../../consts/AuthFields";
import { isTeamUserOwnerOrCoOwner, isUserAdmin } from "../../../../utils/user";

export const QA_ID_PREFIX = `${QA.PAGES.RECIPIENT}-SavedFiltersOptionsMenu`;

const MENU_OPTIONS = [
  {
    label: "View",
    action: "view"
  },
  {
    label: "Share",
    action: "share"
  },
  {
    label: "Duplicate",
    action: "duplicate"
  },
  {
    label: "Delete",
    action: "delete"
  }
];

function SavedFiltersOptionsMenu({
  filter,
  id,
  onView,
  onEdit,
  // onDuplicate,
  deleteFilter,
}) {

  const {
    handleDuplicateRecipientFilter,
    refreshSavedFilters,
  } = useSavedFiltersManagement();

  const {
    user,
    signedInUserIsOwner,
  } = useAppContext();

  const triggerRef = useRef();
  const [isOpen, setIsOpen] = useState(false);
  const [showFilterDeleteModal, setShowFilterDeleteModal] = useState(false);
  const [isDeleteInProgress, setIsDeleteInProgress] = useState(false);
  const [showDuplicateFilterModal, setShowDuplicateFilterModal] = useState(false);
  const [showShareFilterModal, setShowShareFilterModal] = useState(false);
  const [filterName, setFilterName] = useState(filter?.name);

  const handleMenuItemClick = (action) => {
    setIsOpen(false);
    
    switch (action) {
        case "view":
            if (onView) onView(filter);
            break;
        case "duplicate":
            setFilterName(filter?.name ? `${filter.name} - Copy` : "");
            setShowDuplicateFilterModal(true);
            break;
        case "delete":
            setShowFilterDeleteModal(true);
            break;
        case "share":
            setShowShareFilterModal(true);
            break;
        default:
        console.log(`Unknown action: ${action}`);
    }
  };

  const handleDeleteConfirmClick = async (filter) => {
      setIsDeleteInProgress(true);
      await deleteFilter(filter?.filterId);
      refreshSavedFilters(true);
      setIsDeleteInProgress(false);
      setShowFilterDeleteModal(false);
  };

  //check if option should be disabled
  const isOptionDisabled = (action) => {
    if(action === "delete" && (user?.[JWT.UPN]?.toLowerCase() !== filter?.createdBy?.toLowerCase() && !signedInUserIsOwner && !isUserAdmin(user))) { 
      return true;
    }
    return false;
  };

  return (
    <div className="saved-filters-actions-menu" data-testid={`${QA_ID_PREFIX}-wrapper`}>
      <Menu
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        onOpen={() => setIsOpen(true)}
        trigger={<More data-testid={`${QA_ID_PREFIX}-trigger`} />}
        triggerRef={triggerRef}
        data-testid={`${QA_ID_PREFIX}-menu`}
      >
        {MENU_OPTIONS.map((option, index) => (
          <MenuItem
            key={option.action}
            id={`${id}-${QA_ID_PREFIX}-MenuItem-${option.action}`}
            onClick={() => handleMenuItemClick(option.action)}
            data-testid={`${QA_ID_PREFIX}-menu-item-${index}`}
            disabled={isOptionDisabled(option.action)}
          >
            {option.label}
          </MenuItem>
        ))}
      </Menu>
       {/* Filter Delete Modal */}
        <SavedRecipientsDeleteModal
          isOpen={showFilterDeleteModal}
          onClose={() => setShowFilterDeleteModal(false)}
          title={"Delete Recipient Filter"}
          subTitle="Are you sure you want to delete this filter? This action cannot be undone."
          isDeleteInProgress={isDeleteInProgress}
          primaryAction={()=>{
            handleDeleteConfirmClick(filter)
          }}
          secondaryAction={() => {
            setShowFilterDeleteModal(false);
          }}
        />
        <SavedRecipientsCreateModal
          isOpen={showDuplicateFilterModal}
          onClose={() => {
            setShowDuplicateFilterModal(false);
            setFilterName("");
          }}
          title={"Duplicate Recipient Filter"}
          subTitle={"Please assign a name to your duplicated recipient filter list."}
          filterName={filterName}
          setFilterName={setFilterName}
          confirmCreateClick={()=>{
            handleDuplicateRecipientFilter({
              ...filter,
              name: filterName,
            });
            setShowDuplicateFilterModal(false);
          }}
        />
        <SavedRecipientsShareModal
          isOpen={showShareFilterModal}
          onClose={() => setShowShareFilterModal(false)}
          title={"Share Recipient Filter"}
          subTitle={"Select a team member to share this filtered recipient list within your team."}
          filter={filter}
        />
    </div>
  );
}

export default SavedFiltersOptionsMenu;
